// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Vc51","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__s_Mv0"};